import Link from "@/components/link/Link";
import { SEO_TRACK, SEO_URL } from "@/constants/horseRacing";

const oddsLink = (
  <Link next={false} href={SEO_URL[SEO_TRACK.DEL_MAR].ODDS}>
    Breeders&apos; Cup Odds
  </Link>
);

const bettingLink = (
  <Link next={false} href={SEO_URL[SEO_TRACK.DEL_MAR].BETTING}>
    Breeders&apos; Cup Betting
  </Link>
);

const BreedersCupSeo = () => (
  <div>
    The 42nd Breeders&apos; Cup World Championships returns Friday, October 31st
    through Saturday, November 1st, 2025, at the scenic Del Mar Thoroughbred
    Club in California. Experience two days of elite international racing and
    massive payouts as championship titles are decided. Lock in your edge with
    up-to-date {oddsLink} and sharpen your strategy using trusted {bettingLink}{" "}
    analysis on every division.
  </div>
);

export default BreedersCupSeo;
